<template>
  <div class="contents koyoukeiyaku">
    <h2>雇用契約 詳細</h2>
    <div class="container koyoukeiyaku-detail">
      <koyoukeiyaku-detail :koyouKeiyakuId=keiyakuId></koyoukeiyaku-detail>
    </div>
    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.KOYOUKEIYAKU_SEARCH,
        }">検索画面に戻る
        </router-link>
      </p>
    </div><!--button-container-->
  </div><!--contents-->
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { RouterConst } from '@/const/Router';

import KoyouKeiyakuDetail from '@/components/koyoukeiyaku/Detail.vue';

export default defineComponent({
  setup() {
    // クエリ文字列より雇用契約書IDを取得
    const route = useRoute()
    const keiyakuId = parseInt(route.params.id as string, 10)

    return {
      RouterConst,
      KoyouKeiyakuDetail,
      keiyakuId
    }
  },
  components: {
    'koyoukeiyaku-detail':KoyouKeiyakuDetail,
  }
})

</script>